"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var react_1 = __importStar(require("react"));
var yup_1 = require("yup");
var react_hook_form_1 = require("react-hook-form");
var FormSchema_1 = require("./FormSchema");
var yup_2 = require("@hookform/resolvers/yup");
var UseYupLocalization_1 = require("../localization/UseYupLocalization");
/**
 * Renders an HTML form element and the children inputs, and wraps them all within a react-hook-form provider
 *
 * @typeParam TFormSchema - typescript interface of your form
 * @typeParam TContext - an optional type that matches the optional yup context
 * @example
 * ```
 * <FormTextInput<{foo: string; bar: number}, "foo"> name="foo" ...TextInputProps
 * ```
 */
var Form = function (_a) {
    var children = _a.children, createSchema = _a.createSchema, onSubmitSuccess = _a.onSubmitSuccess, onSubmitError = _a.onSubmitError, 
    // the rest of these props are react-hook-form props and we're setting default values for some
    _b = _a.mode, 
    // the rest of these props are react-hook-form props and we're setting default values for some
    mode = _b === void 0 ? 'onChange' : _b, _c = _a.criteriaMode, criteriaMode = _c === void 0 ? 'firstError' : _c, _d = _a.reValidateMode, reValidateMode = _d === void 0 ? 'onChange' : _d, _e = _a.shouldFocusError, shouldFocusError = _e === void 0 ? true : _e, formDefaultValues = _a.defaultValues, formProps = __rest(_a, ["children", "createSchema", "onSubmitSuccess", "onSubmitError", "mode", "criteriaMode", "reValidateMode", "shouldFocusError", "defaultValues"]);
    if (!createSchema) {
        console.warn('No createSchema property was passed. Unable to retrieve form schema.');
    }
    // We have to localize Yup BEFORE creating the schema
    (0, UseYupLocalization_1.useYupLocalization)();
    var schema = (0, react_1.useMemo)(function () { return (createSchema ? createSchema() : (0, yup_1.object)()); }, [createSchema]);
    // Use default values from the schema if they exist
    var defaultValues = (0, react_1.useMemo)(function () {
        //@ts-expect-error
        var schemaDefaults = schema.default();
        var finalDefaults = __assign(__assign({}, schemaDefaults), formDefaultValues);
        return finalDefaults;
    }, [formDefaultValues, schema]);
    var methods = (0, react_hook_form_1.useForm)(__assign(__assign({}, formProps), { defaultValues: defaultValues, mode: mode, reValidateMode: reValidateMode, criteriaMode: criteriaMode, shouldFocusError: shouldFocusError, resolver: (0, yup_2.yupResolver)(schema) }));
    return (react_1.default.createElement(react_hook_form_1.FormProvider, __assign({}, methods),
        react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmitSuccess, onSubmitError), noValidate: true },
            react_1.default.createElement(FormSchema_1.FormSchemaProvider, { schema: schema }, children))));
};
exports.Form = Form;
